import { Button, Drawer, Tabs, Tooltip } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import React from 'react';
import {
  JobHistoryServiceProxy,
  PageJobHistoriesOutputDto,
  PageSearchJobHistoriesInputDto,
  OrderFormServiceProxy,
  ExportFileServiceProxy,
} from '../../services/serviceProxy';
import { AppTopNaviDivider } from '@abb/abb-common-ux-react';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import { ProTable, ProColumns } from '@ant-design/pro-components';
import moment from 'moment';
import AbbIcon from '../../packages/AbbIcon';
import { L } from '../../lib/abpUtility';
class PendingTask extends React.Component {
  formRef = React.createRef<FormInstance>();
  private _jobHistory = new JobHistoryServiceProxy();

  state = {
    visible: false,
    loading: false,
    retryLoading: false,
    maxResultCount: 50,
    skipCount: 0,
    current: 1,
    totalCount: 0,
    jobHistories: [],
  };
  private _exportFileServiceProxy=new ExportFileServiceProxy();

  // 列定义
  get jobHistoryColumns(): ProColumns<PageJobHistoriesOutputDto>[] {
    return [
      {
        title: '任务状态',
        dataIndex: 'jobStatus',
        key: 'jobStatus',
        width: 68,
        align: 'center',
        render: (flag: boolean, record) => (
          <Tooltip
            title={`执行时间：${moment(record.startTime).format('YYYY/MM/DD HH:mm:ss')}${
              record.endTime ? ` - ${moment(record.endTime).format('YYYY/MM/DD HH:mm:ss')}` : ''
            }`}
            placement="bottom"
          >
            {record.jobStatus ? (
              <CheckCircleOutlined style={{ fontSize: '20px', color: '#67C23A' }} />
            ) : record.jobStatus == null ? (
              <ClockCircleOutlined style={{ fontSize: '20px', color: '#909399' }} />
            ) : (
              <CloseCircleOutlined style={{ fontSize: '20px', color: '#909399' }} />
            )}
          </Tooltip>
        ),
      },
      {
        title: '任务名称',
        dataIndex: 'jobName',
        key: 'jobName',
      },
      {
        title: '操作人',
        dataIndex: 'operaterName',
        key: 'operaterName',
        width: 120,
      },
      {
        title: '重试次数',
        dataIndex: 'retryCount',
        key: 'retryCount',
        width: 68,
      },
      {
        title: '执行结果',
        dataIndex: 'jobResult',
        key: 'jobResult',
        render: (text: string, record) => {
          const regexp = /(http|https):\/\/[\w]+(.[\w]+)([\w\-.,@?^=%&:/~+#\u4e00-\u9fa5]*[\w\-@?^=%&/~+#])/;
          if(record.jobStatus&&record.jobType==1&&!regexp.test(text)){
             return (
              <Button type="link" onClick={() =>  this._exportFileServiceProxy.downloadFileStream(text)}>
                {record.jobName}
              </Button>
            );
          }
          if (regexp.test(text)) {
            //若是下载链接，直接下载
            return (
              <Button type="link" onClick={() => this.handleDownload(text, record.jobName)}>
                {record.jobName}
              </Button>
            );
          } else return text;
        },
      },
      {
        title: '操作',
        width: 68,
        render: (text, record) => {
          return (
            <div className="ant_anticon">
              {!record.jobStatus && record.jobStatus != null ? (
                <Tooltip title="重试" placement="bottom">
                  <RedoOutlined onClick={() => this.handleJobRetry(record)} onLoad={this.Loading} />
                </Tooltip>
              ) : (
                ''
              )}
            </div>
          );
        },
      },
    ];
  }

  Loading = () => {
    this.setState({
      loading: !this.state.loading,
    });
  };

  async componentDidMount() {}

  handleShowDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  handleCloseDrawer = () => {
    this.setState({
      visible: false,
    });
  };

  handleChangTabs = (activeKey) => {
    switch (activeKey) {
      case 'export':
        this.getJobHistories();
        break;
      case 'pending':
        break;
      default:
        break;
    }
  };
  private _orderFormService = new OrderFormServiceProxy();
  handleDownload = async (url: string, fileName: string) => {
    const downfileName = url.split('/').pop();
    const url_copy = await this._orderFormService.getTemporaryFileUrl(downfileName); //url;        
    const link = document.createElement('a');
    link.href = url_copy;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  };

  //查询任务列表
  getJobHistories = async () => {
    this.Loading();
    const { current, maxResultCount } = this.state;

    // 调用接口查询
    const skipCount = (current - 1) * maxResultCount;

    const param = new PageSearchJobHistoriesInputDto();
    param.maxResultCount = maxResultCount;
    param.skipCount = skipCount;
    param.keyword = '';
    await this._jobHistory.pageSearchJobHistories(param).then((resp) => {
      this.setState({
        jobHistories: resp.items,
        totalCount: resp.totalCount,
      });
      this.Loading();
    });
  };

  handleJobRetry = (record) => {
    this._jobHistory.taskRetry(record.jobId).then(() => {
      this.getJobHistories();
    });
  };

  render() {
    return (
      <>
        <Button icon={<AbbIcon name="abb_export" />} type="text" onClick={this.handleShowDrawer}>
          导出
        </Button>
        <AppTopNaviDivider />
        <Drawer
          title={L('Export')}
          placement="right"
          closable={this.state.visible}
          onClose={this.handleCloseDrawer}
          open={this.state.visible}
          destroyOnClose={true}
          width={'50%'}
          style={{ position: 'absolute' }}
        >
          <Tabs defaultActiveKey="1" onChange={this.handleChangTabs}>
            <Tabs.TabPane tab="导出列表" key="export">
              <ProTable<PageJobHistoriesOutputDto>
                pagination={{
                  current: this.state.current,
                  total: this.state.totalCount,
                  defaultCurrent: 1,
                  defaultPageSize: 50,
                  showSizeChanger: true,
                }}
                request={async (params) => {
                  this.setState(
                    {
                      maxResultCount: params.pageSize,
                      current: params.current,
                    },
                    async () => await this.getJobHistories()
                  );
                  return Promise.resolve({
                    data: this.state.jobHistories,
                    success: true,
                    total: this.state.totalCount,
                  });
                }}
                scroll={{ scrollToFirstRowOnChange: true, x: 'max-content' }}
                columns={this.jobHistoryColumns}
                options={false}
                search={false}
                dataSource={this.state.jobHistories}
                loading={this.state.loading}
              />
            </Tabs.TabPane>
            {/* <Tabs.TabPane tab="待开发" key="pending">
                            开发中...
                        </Tabs.TabPane> */}
          </Tabs>
        </Drawer>
      </>
    );
  }
}

export default PendingTask;
